import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';

import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  startAfter,
  getCountFromServer
} from 'firebase/firestore';

import './journal.css';

function Glaucoma() {

  const [glaucomaBooks, setGlaucomaBooks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Glaucoma Resources
  const fetchGlaucomaBooks = async (page) => {

    try {

      const pageSize = 6;

      const resourcesRef = collection(db, 'mainresources');

      let q = query(
        resourcesRef,
        where(
          'resourceType',
          '==',
          'Glaucoma'
        ),
        orderBy('created_at', 'desc'),
        limit(pageSize)
      );

      // Pagination
      if (page > 1 && lastVisible) {

        q = query(
          resourcesRef,
          where(
            'resourceType',
            '==',
            'Glaucoma'
          ),
          orderBy('created_at', 'desc'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);

      const books = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setGlaucomaBooks(books);

      setLastVisible(
        querySnapshot.docs[querySnapshot.docs.length - 1]
      );

      // Count Total Documents
      const countSnapshot = await getCountFromServer(
        query(
          resourcesRef,
          where(
            'resourceType',
            '==',
            'Glaucoma'
          )
        )
      );

      const pages = Math.ceil(
        countSnapshot.data().count / pageSize
      );

      setTotalPages(pages);

    } catch (error) {

      console.error(
        'Error fetching Glaucoma resources:',
        error
      );
    }
  };

  // Pagination Handler
  const paginate = (page) => {
    setCurrentPage(page);
    fetchGlaucomaBooks(page);
  };

  useEffect(() => {
    fetchGlaucomaBooks(currentPage);
  }, [currentPage]);

  return (

    <div className="journal-page-container">

      {/* HERO SECTION */}
      <section className="hero">

        <div className="hero-image">
          <img
            src="/imgbook.png"
            alt="Glaucoma Resources"
          />
        </div>

        <div className="hero-content">

          <h1>Eye Care Digital Library</h1>

          <p>
            Explore professional educational books,
            clinical guides, and research resources
            focused on glaucoma diagnosis, treatment,
            disease management, and modern ophthalmic
            care practices.
          </p>

        </div>

      </section>

      {/* PAGE HEADER */}
      <div className="journal-heading-section">

        <h2>Glaucoma</h2>

        <p>
          Access comprehensive resources covering
          glaucoma pathology, intraocular pressure
          management, visual field analysis,
          optic nerve assessment, medications,
          laser procedures, and surgical treatment
          techniques.
        </p>

      </div>

      {/* BOOKS GRID */}
      <div className="articles-container">

        {glaucomaBooks.length > 0 ? (

          glaucomaBooks.map((book) => (

            <div
              key={book.id}
              className="article-item"
            >

              {/* COVER IMAGE */}
              {book.coverImageURL && (
                <img
                  src={book.coverImageURL}
                  alt={book.title}
                  className="book-cover-image"
                />
              )}

              {/* TITLE */}
              <h4>{book.title}</h4>

              {/* METADATA */}
              <div className="book-meta-data">

                {book.author && (
                  <p>
                    <strong>Author:</strong> {book.author}
                  </p>
                )}

                {book.publication_year && (
                  <p>
                    <strong>Publication Year:</strong>{' '}
                    {book.publication_year}
                  </p>
                )}

                {book.isbn && (
                  <p>
                    <strong>ISBN:</strong> {book.isbn}
                  </p>
                )}

              </div>

              {/* DESCRIPTION */}
              {book.description && (
                <p className="book-description">
                  {book.description}
                </p>
              )}

              {/* READ BUTTON */}
              {book.pdfFileURL && (
                <a
                  href={book.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read Book
                </a>
              )}

            </div>

          ))

        ) : (

          <div className="no-books-found">

            <h3>No Resources Available</h3>

            <p>
              No Glaucoma resources have been
              uploaded yet.
            </p>

          </div>

        )}

      </div>

      {/* PAGINATION */}
      {totalPages > 1 && (

        <div className="pagination-container">

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from(
            { length: totalPages },
            (_, index) => (
              <button
                key={index + 1}
                className={`pagination-button ${
                  currentPage === index + 1
                    ? 'active'
                    : ''
                }`}
                onClick={() => paginate(index + 1)}
              >
                {index + 1}
              </button>
            )
          )}

          <button
            className="pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>

        </div>

      )}

    </div>
  );
}

export default Glaucoma;